// Helper partagé client + serveur pour produire le nom d'affichage d'un
// apporteur, qu'il soit une personne physique (`type='person'`) ou une
// structure morale (`type='company'`). Les champs pertinents sont garantis
// non-null pour le type concerné par le CHECK SQL
// `apporteurs_type_consistency_chk`.
//
// Pattern miroir de `src/shared/prospect.ts::displayName` pour les prospects.

export type ApporteurDisplayFields = {
  type: 'person' | 'company';
  companyName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
};

export function displayName(a: ApporteurDisplayFields): string {
  if (a.type === 'company') {
    return a.companyName ?? '(sans nom)';
  }
  const full = `${a.firstName ?? ''} ${a.lastName ?? ''}`.trim();
  return full === '' ? '(sans nom)' : full;
}
